import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  BorderProp,
  DesignProp,
  PaddingsProp,
  SizeProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "horizontalLine",
  meta: {},
  /* TODO: Update with the new style props */
  props: {
    width: {
      prop: "other",
      type: "slider",
      value: "100%",
      meta: {
        name: "Width",
        nameI18n: "builder_ui.prop_type.styles.width",
        sliderProps: {
          step: 1,
          max: 1920,
        },
        category: [DesignProp, SizeProp],
      },
    },
    borderStyle: {
      prop: "other",
      type: "select",
      value: "solid",
      options: [
        {
          value: "Solid",
          label: "builder_ui.prop_type.styles.border_style_types.solid",
        },
        {
          value: "Dashed",
          label: "builder_ui.prop_type.styles.border_style_types.dashed",
        },
      ],
      meta: {
        name: "Border Style",
        nameI18n: "builder_ui.prop_type.styles.border_style",
        category: [DesignProp, BorderProp],
      },
    },
    color: {
      prop: "other",
      type: "color",
      value: "var(--theme-website-color-border-primary)",
      meta: {
        name: "Color",
        nameI18n: "builder_ui.prop_type.styles.color",
        category: [DesignProp, BorderProp],
      },
    },
    borderWidth: {
      prop: "other",
      type: "slider",
      value: 1,
      meta: {
        name: "Border Width",
        nameI18n: "builder_ui.prop_type.styles.border_width",
        sliderProps: {
          units: ["px"],
          step: 1,
          min: 1,
          max: 10,
        },
        category: [DesignProp, BorderProp],
      },
    },
    paddingY: {
      prop: "other",
      type: "slider",
      value: 0,
      meta: {
        name: "Top & bottom",
        nameI18n: "builder_ui.prop_type.padding_y",
        sliderProps: {
          units: ["px", "rem"],
          step: 0.25,
        },
        category: [DesignProp, PaddingsProp],
      },
    },
    paddingX: {
      prop: "other",
      type: "slider",
      value: 0,
      meta: {
        name: "Left & right",
        nameI18n: "builder_ui.prop_type.padding_x",
        sliderProps: {
          units: ["px", "rem"],
          step: 0.25,
        },
        category: [DesignProp, PaddingsProp],
      },
    },
  },
};
